module.exports = __webpack_public_path__ + "static/media/us-founders-club.edb26b88.png";